module.exports = __webpack_public_path__ + "img/weixin.d6c96817.jpeg";